<template>
        <b-sidebar
            lazy
            :visible="store.state[storeModuleName].isAddNewElementSidebarCollapsed"
            bg-variant="white"
            sidebar-class="sidebar-lg w-100"
            shadow
            backdrop
            no-header
            right
            @hidden="()=> {
                store.commit(`${storeModuleName}/SET_ELEMENT_IN_EDIT`, null)
                store.commit(`${storeModuleName}/SET_IS_ADD_NEW_ELEMENT_COLLAPSED`, false)

            }"
            style="width: 100%"
        >

            <template #default="{ hide }">
                <b-overlay :show="store.state[storeModuleName].isAddNewElementSidebarBusy" no-wrap spinner-variant="primary"></b-overlay>
                <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
                    <h5 class="mb-0">
                      {{sidebarHeader}}
                    </h5>
                    <feather-icon
                      class="ml-1 cursor-pointer"
                      icon="XIcon"
                      size="16"
                      @click="hide"
                    />

                </div>
                <div class="px-2 py-1">
                    <slot name="addDataForm"></slot>
                </div>
            </template>
        </b-sidebar>

</template>

<script>

import { BSidebar, BOverlay, } from 'bootstrap-vue'


import store from '@/store'

export default {
  components: {
      BSidebar,
      BOverlay
  },
  props: {
      //static content
      sidebarHeader: {
          type: String,
          required: false,
      },
      storeModuleName: {
          type: String,
          default: "",
          required: true
      },
  },

    setup() {
      return {
          store,
      }
    }
}
</script>

